import { render, staticRenderFns } from "./PopupTemplate.vue?vue&type=template&id=128e341a&scoped=true&"
import script from "./PopupTemplate.vue?vue&type=script&lang=js&"
export * from "./PopupTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PopupTemplate.vue?vue&type=style&index=0&id=128e341a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e341a",
  null
  
)

export default component.exports